import { colors as equinorColors } from '@equinor/opt-ui-core';
import { ModelEntityStatusType } from 'Utils/API/types/omniaPreventController';
// BSU = base spacing unit. Defaulted to 8px
export const bsu = 8;
// Colors
// -------------------------
export const colors = {
    WHITE: '#FFF',
    BLACK: '#000',
    OFF_WHITE: '#FFFFFE',
    ALMOND: '#D5762F',
    GOLD: '#C68600',
    SLATE_BLUE_100: '#243746',
    SLATE_BLUE_80: '#505F6B',
    SLATE_BLUE_50: '#919BA2',
    SLATE_BLUE_30: '#BDC3C8',
    SLATE_BLUE_20: '#D3D7DA',
    SLATE_BLUE_06: '#F2F3F4',
    BG_DARK_100: '#132634',
    BG_DARK_200: '#162935',
    THEAD_DARK: '#66737E',
    NEW_DARK_BLUE: '#092237',
    IOC_GRAY: '#DADADA',
    IOC_GRAY_DC: '#DCDCDC',
    UNNAMED_DARK: '#3A4B58',
    MOSS_GREEN_100: '#007079',
    MOSS_GREEN_55: '#73B1B5',
    MOSS_GREEN_34: '#A8CED1',
    MOSS_GREEN_21: '#C9E0E2',
    MOSS_GREEN_FOCUS_13: '#DEEDEE',
    MOSS_GREEN_HOVER_DARKER: '#004E55',
    MOSS_LIGHT: '#EDF5F6',
    MOSS_DARK: '#058690',
    INTERACTIVE_DANGER: '#EB0000',
    ENERGY_RED_100: '#EB0037',
    RED_ALERT_55: '#E24973',
    SUCCESS_GREEN: '#32A610',
    RED_ALERT_ELEMENTS: '#FF0000',
    RED_ALERT_TEXT: '#D70303',
    RED_ALERT_BACKGROUND: '#F1DFDF',
    BRAND_ENERGY_RED: '#FF1243',
    BRAND_HERITAGE_RED: '#7D0023',
    BRAND_EQUINOR_BLACK: '#333333',
    BRAND_SPRUCE_WOOD: '#FFE7D6',
    BRAND_LICHEN_GREEN: '#E6FAEC',
    BRAND_MIST_BLUE: '#D5EAF4',
    // OLD EQUINOR COLORS
    EQUINOR_DISABLED: '#E6E5E6',
    EQUINOR_BLACK: '#333333',
    EQUINOR_DARK_GRAY: '#666666',
    EQUINOR_GRAY: '#999999',
    EQUINOR_BORDER: '#DDDDDD',
    EQUINOR_MEDIUM_GRAY: '#C2C2C2',
    EQUINOR_LIGHT_GRAY: '#F2F2F2',
    MINT: '#DEFAEB',
    // Sparkline
    /*
      Need to get confirmation from UX/UI that these are
      the correct colors, and that each color corresponds to
      the correct value.
      Has already been flagged to Petter and Claudelle.
      Also need to fix names to something intuitive.
    */
    SPARKLINE_NEGATIVE: '#919BA2',
    SPARKLINE_ZERO: '#FFFFFF',
    SPARKLINE_ONE: '#42B121',
    SPARKLINE_TWO: '#ABE482',
    SPARKLINE_THREE: '#FF5F00',
    SPARKLINE_FOUR: '#30D5D7',
    SPARKLINE_FIVE: '#F5CD1E',
    SPARKLINE_SIX: '#FF0000',
    // Custom colors for this app (not defined in style guide)
    apricotPeach: '#FBCFB0', // A more saturated spruceWood
    altoGrey: '#d3d3d3', // A darker lightGrey
    alabaster: '#fafafa', // Even lighter grey :P
    paleSky: '#66737e', // Menu links
    // New design colors for UX
    lightBlue: '#a8ced1', // header button colors
    backgroundTeal: '#deedee', // dropdown list item hover color
    shuttleGrey: '#505f6b', // on focus background
    submarine: '#bdc3c8', // Cool blue grey
    porcelain: '#eaeeee',
    // wireframe colors
    lightGrey: '#717070',
    ERLA_LIGHT_BLUE: '#C4E8FC',
    // Alarm Limits
    ALERT_RED: '#FF0000',
    ALERT_YELLOW: '#F4C90F',
    ALERT_YELLOW_HOVER_DARKER: '#d2ac09',
    ALERT_YELLOW_HIGHLIGHT: '#F3FF0033',
    ALERT_TURQUOISE: '#21D1D4',
    ALERT_GREEN: '#51C55B',
    FEEDBACK_PURPLE: '#86A8E7',
    HOT_PINK: '#FF0080',
    // Monitoring page dark mode colors
    GRAFANA_BLUE: '#212337',
    MATTE_BLACK: '#202020',
    // Event chip colors
    EVENT_INTERACTION_STATUS_CHIP_COLOR: '#F09737',
    ALARM_CHIP_COLOR: '#CBE3F1',
    BACKGROUND_DARK: '#0E1F2A',
    CONTROL_DARK: '#142633',
    TEXT_GREY: '#9CA6AC',
    TEXT_CYAN: '#97CACE',
    TANGAROA: '#0F1D26',
    SHADED_BLACK: '#081116'
};
const goldenOrange = '#FF9200';
const lightBlue = '#71C7F8'; // custom
const pinkRose = equinorColors.pinkRose; // '#e24973';
const weathered = '#7d0023'; // equinorColors.weathered; // '#7d0023';
export const ModelEntityStatusColors = {
    [ModelEntityStatusType.New]: lightBlue,
    [ModelEntityStatusType.Active]: goldenOrange,
    [ModelEntityStatusType.Archived]: weathered,
    other: pinkRose
};
// Depth
// -------------------------
export const zIndex = {
    modal: 9000,
    pageBarLoader: 8000,
    header: 7000,
    toaster: 6000,
    sidebarHover: 5000,
    dropdown: 4000,
    popover: 4000,
    controls: 4000,
    subheader: 3000,
    sidebar: 2000,
    backdrop: 1200,
    tabs: 1200
};
// Fonts
// -------------------------
export const borderRadius = {
    base: '3px'
};
export const boxElementsDimensions = {
    sidebarNavWidth: 320,
    sidebarCommentsWidth: 320
};
export const customScreenSizes = {
    tabsBottomScreenResolution: 900,
    sidebarNavTrigger: 1310,
    sidebarCommentsTrigger: 1366
};
export const screenSizes = {
    sm: 375,
    md: 768,
    lg: 1024,
    xl: 1280,
    xxl: 1366
};
export const breakpoints = {
    smOnly: `max-width: ${screenSizes.md - 1}px`,
    mdUp: `min-width: ${screenSizes.md}px`,
    lgUp: `min-width: ${screenSizes.lg}px`,
    xlUp: `min-width: ${screenSizes.xl}px`,
    smDown: `max-width: ${screenSizes.sm}px`,
    mdDown: `max-width: ${screenSizes.md}px`,
    lgDown: `max-width: ${screenSizes.lg}px`,
    xlDown: `max-width: ${screenSizes.xl}px`,
    edgecase: 'max-width: 1800px'
};
export const gutters = {
    sm: bsu * 1.5,
    md: bsu * 3,
    lg: bsu * 5
};
export const containerSizes = {
    SMALL: '800px',
    MEDIUM: '1000px',
    LARGE: '1312px'
};
export const ContainerSize = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large'
};
// Theme
export var MODES;
(function (MODES) {
    MODES["DARK"] = "dark";
    MODES["LIGHT"] = "light";
})(MODES || (MODES = {}));
export const APP_THEME = { mode: MODES.DARK };
export const headerHeight = 63;
const mainSectionControlsHeight = 40;
const filtersPanelHeight = 36;
const filtersStateHeight = 28;
const eventsPageTabsHeight = 52;
export const monitoringPageEventsTopSectionHeight = (showFilterState) => showFilterState
    ? headerHeight +
        mainSectionControlsHeight +
        filtersPanelHeight +
        filtersStateHeight +
        eventsPageTabsHeight
    : headerHeight + mainSectionControlsHeight + filtersPanelHeight + eventsPageTabsHeight;
export const newTabTableWidth = 1715;
export const monitoringWatchlistTabTableWidth = 1670;
export const readyForTrainingTabTableWidth = 1720;
export const trainedTabTableWidth = 1520;
export const archivedTabTableWidth = 2000;
